import { Component, Input, OnChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';

import { BasePackagingComponent } from '../_base-packaging.component';


@Component({
  moduleId: module.id,
  selector: 'shipping-information',
  templateUrl: 'shipping-information.component.html',
  styleUrls: ['shipping-information.component.scss'],
})
export class ShippingInformationComponent extends BasePackagingComponent implements OnChanges {

  @Input() declare itemDetailsData: any;

  @Input() declare data: any;

  @Input() expiCodes: Array<any>;

  @Input() formGroup: UntypedFormGroup;

  shippingData: Array<any> = [];
  shippingFields: Array<string> = [
    'package_level_GTIN', 'package_bar_code_characters',
    'electronic_product_code', 'stacking_factor',
    'inner_quantity', 'inner_quantity_uom',
  ];

  ngOnChanges() {
    this.prepareData();
  }

  prepareData() {
    this.shippingData = this.filterData(this.data, this.shippingFields);
  }

}
